import { render, staticRenderFns } from "./AddDebris.vue?vue&type=template&id=099c5aca&scoped=true&"
import script from "./AddDebris.vue?vue&type=script&lang=js&"
export * from "./AddDebris.vue?vue&type=script&lang=js&"
import style0 from "./AddDebris.vue?vue&type=style&index=0&id=099c5aca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099c5aca",
  null
  
)

export default component.exports